export enum EnumConceptType {
  Energy_Cost_Gas_consumption_charge_Cliente_Final = 1,
  Toll_Gas_fix_Cliente_Final = 2,
  Others_Distribuidor = 3,
  Renting_Gas_renting_Distribuidor = 4,
  Special_energy_tax_Gas_Cliente_Final = 5,
  VAT_Gas_Cliente_Final = 6,
  ATR_Cliente_Final = 7,
  Margen_Cliente_Final = 8,
  Término_Variable_Distribuidor = 9,
  Término_Fijo_Distribuidor = 10,
  Derechos_Distribuidor = 11,
  Término_Fijo_Mayorista = 157,
  Término_Variable_Mayorista = 158,
  Alquileres_Mayorista = 159,
  Otros_Mayorista = 160,
  Base_imponible_Mayorista = 161,
  IVA_Mayorista = 162,
  Importe_Total_Mayorista = 163,
  Suministro_de_Molécula_Mayorista = 164,
  ATR_Distribución_Mayorista = 165,
  Cobertura_Mayorista = 166,
  Tolerancia_Mayorista = 167,
  ATR_upstream_Mayorista = 168,
  Tasa_por_uso_del_gas_Mayorista = 169,
  Tasa_sobre_precio_molécula_Mayorista = 170,
  Bonificación_por_nominación_Mayorista = 171,
  Costes_y_Tasas_Mayorista = 172,
  Término_Fijo_Comercial = 173,
  Término_Variable_Comercial = 174,
  Alquileres_Comercial = 175,
  Otros_Comercial = 176,
  Base_imponible_Comercial = 177,
  IVA_Comercial = 178,
  Importe_Total_Comercial = 179,
  Suministro_de_Molécula_Comercial = 180,
  ATR_Distribución_Comercial = 181,
  Cobertura_Comercial = 182,
  Tolerancia_Comercial = 183,
  ATR_upstream_Comercial = 184,
  Tasa_por_uso_del_gas_Comercial = 185,
  Tasa_sobre_precio_molécula_Comercial = 186,
  Bonificación_por_nominación_Comercial = 187,
  Costes_y_Tasas_Comercial = 188,
  Coste_TTA_Transportista = 189,
  Coste_DIST_Distribuidor = 190,
  Término_de_Potencia_Distribuidor = 300,
  Toll_Power_capacity_excess_charge_Distribuidor = 301,
  Término_de_Energía_Activa_Distribuidor = 302,
  Término_de_Energía_Reactiva_Distribuidor = 303,
  Renting_Power_renting_Distribuidor = 304,
  Intereses_de_demora_Distribuidor = 305,
  Otros_Distribuidor = 306,
  IVA_Distribuidor = 307,
  Término_de_Potencia_Cliente_Final = 308,
  Término_de_Excesos_de_Potencia_Cliente_Final = 309,
  Energy_Cost_Power_consumption_charge_Cliente_Final = 310,
  Término_de_Energía_Reactiva_Cliente_Final = 311,
  Special_energy_tax_Power_Cliente_Final = 312,
  Toll_Power_peaje_energy_Cliente_Final = 313,
  Peajes_de_Energía_Activa_Cliente_Final = 314,
  Cargos_de_Potencia_Cliente_Final = 315,
  Cargos_de_Energía_Activa_Cliente_Final = 316,
  Término_Energía_Capacitiva_Distribuidor = 317,
  Término_de_Cargos_de_Potencia_Distribuidor = 318,
  Término_de_Cargos_de_Energía_Activa_Distribuidor = 319,
  Floltantes_Distribuidor = 1157,
  ATR_Fijo_Cliente_Final = 1201,
  ATR_Variable_Cliente_Final = 1202,
  Fijo17b = 1203,
  Variable17b = 1204,
  Consumo_Cliente_Final = 1300,
  Toll_Gas_variable_Cliente_Final = 2203,
  VAT_Power_Cliente_Final = 2204,
  Toll_Gas_taxes_Cliente_Final = 2205,
  Toll_Gas_others_Cliente_Final = 2206,
  Toll_Power_reactive_Distribuidor = 2207,
  Toll_Power_charges_active_Cliente_Final = 2208,
  Toll_Power_charges_potencia_Cliente_Final = 2209,
  Toll_Power_peaje_potencia_Cliente_Final = 2210,
  Renting_Gas_others_Distribuidor = 2211,
  Renting_Power_others_Distribuidor = 2212,
  Energy_Cost_Gas_Coverage_Cliente_Final = 2213,
  Energy_Cost_Gas_Fixation_Cliente_Final = 2214,
  Energy_Cost_Gas_others_Cliente_Final = 2215,
  Energy_Cost_Power_Coverage_Cliente_Final = 2216,
  Energy_Cost_Power_Fixation_Cliente_Final = 2217,
  Energy_Cost_Power_others_Cliente_Final = 2218,
  Energy_Cost_Power_Price_GdO_Cliente_Final = 2219,
  Toll_Power_peaje_energy_Distribuidor = 2220
}
